import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CHANGE_VOTE, CLEAR_POLLS, DELETEPOLL, EDIT_POLL, RECEIVE_ANSWER, RECEIVE_POLL, REGISTER_VOTE, REMOVE_POLL, RESET_NB_UNREAD_POLLS, RETRACT_VOTE, SAVE_POLL, UPDATEPOLL } from './actionTypes';
const INITIAL_STATE = {
    polls: {},
    // Number of not read message
    nbUnreadPolls: 0,
    pollId: ''
};
const STORE_NAME = 'features/polls';
ReducerRegistry.register(STORE_NAME, (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHANGE_VOTE: {
            const { pollId, value } = action;
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [pollId]: {
                        ...state.polls[pollId],
                        changingVote: value,
                        showResults: !value
                    }
                }
            };
        }
        case CLEAR_POLLS: {
            return {
                ...state,
                ...INITIAL_STATE
            };
        }
        // Reducer triggered when a poll is received or saved.
        case RECEIVE_POLL: {
            console.log('RECEIVE_POLL');
            console.log(state);
            console.log(action.poll);
            let add = true;
            if (state.polls[action.pollId])
                add = false;
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [action.pollId]: action.poll
                },
                nbUnreadPolls: action.notify ? state.nbUnreadPolls + (add ? 1 : 0) : 0
            };
        }
        case SAVE_POLL: {
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [action.pollId]: action.poll
                }
            };
        }
        // Reducer triggered when an answer is received
        // The answer is added  to an existing poll
        case RECEIVE_ANSWER: {
            const { pollId, answers, votersById } = action;
            if (!state.polls[pollId]) {
                return {
                    ...state
                };
            }
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [pollId]: {
                        ...state.polls[pollId],
                        answers: answers,
                        votersById: votersById || ''
                    }
                }
            };
        }
        case REGISTER_VOTE: {
            const { answers, pollId, showResults } = action;
            console.log('REGISTER_VOTE', showResults);
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [pollId]: {
                        ...state.polls[pollId],
                        changingVote: false,
                        lastVote: answers,
                        showResults: showResults ?? state.polls[pollId]
                    }
                }
            };
        }
        case RESET_NB_UNREAD_POLLS: {
            return {
                ...state,
                nbUnreadPolls: 0
            };
        }
        case EDIT_POLL: {
            // return {
            //     ...state,
            //     polls: {
            //         ...state.polls,
            //         [action.pollId]: {
            //             ...state.polls[action.pollId],
            //             editing: action.editing
            //         }
            //     }
            // };
            return {
                ...state,
                pollId: action.pollId
            };
        }
        case REMOVE_POLL: {
            if (Object.keys(state.polls ?? {})?.length === 1) {
                return {
                    ...state,
                    ...INITIAL_STATE
                };
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [action.pollId]: _removedPoll, ...newState } = state.polls;
            return {
                ...state,
                polls: {
                    ...newState
                }
            };
        }
        case UPDATEPOLL: {
            console.log('UPDATEPOLL');
            console.log(action.pollId);
            console.log(action.poll);
            console.log(state.polls);
            try {
                const oldPoll = state.polls[action.pollId];
                const newPoll = { ...oldPoll, ...action?.poll };
                const newState = {
                    ...state,
                    polls: {
                        ...state.polls,
                        // The poll is added to the dictionnary of received polls
                        [action.pollId]: newPoll
                    }
                };
                return newState;
            }
            catch (error) {
                console.error(error);
                return state;
            }
        }
        case DELETEPOLL: {
            const newPoll = state.polls;
            delete newPoll[action.pollId];
            const newState = {
                ...state,
                polls: newPoll,
                nbUnreadPolls: state.nbUnreadPolls > 0 ? state.nbUnreadPolls - 1 : 0
            };
            return newState;
        }
        case RETRACT_VOTE: {
            const { pollId } = action;
            return {
                ...state,
                polls: {
                    ...state.polls,
                    [pollId]: {
                        ...state.polls[pollId],
                        showResults: false
                    }
                }
            };
        }
        default:
            return state;
    }
});
